module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Share-ed85633bcff3bc86660d5b89d92fb4e1.svg";